import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "dialog-custom__title mb-0" }
const _hoisted_2 = { class: "fs-18 text-gray" }
const _hoisted_3 = { class: "dialog-custom__content form-custom" }
const _hoisted_4 = { style: {"height":"calc(100vh - 330px)"} }
const _hoisted_5 = { class: "plant-type-selection" }
const _hoisted_6 = { class: "centered" }
const _hoisted_7 = { class: "px-3 mt-3 text-dark" }
const _hoisted_8 = { class: "text-dark" }
const _hoisted_9 = {
  key: 0,
  class: "residential-plant-type"
}
const _hoisted_10 = { class: "mx-3" }
const _hoisted_11 = { class: "text-dark" }
const _hoisted_12 = { class: "text-gray" }
const _hoisted_13 = { class: "residential-type-card__content" }
const _hoisted_14 = { class: "residential-type-card__icon bt-icon" }
const _hoisted_15 = { class: "residential-type-card__head ml-4" }
const _hoisted_16 = { class: "text-gray" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectButton = _resolveComponent("SelectButton")
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Card = _resolveComponent("Card")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("header", {
      "data-plant": _ctx.$attrs.plantId,
      class: "dialog-custom__header"
    }, [
      _createVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t("AppResource.Typeofplant")), 1),
      _createVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("AppResource.TypeofplantDescription").toUpperCase()), 1)
    ], 8, ["data-plant"]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_ElScrollbar, null, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_5, [
              _createVNode(_component_SelectButton, {
                modelValue: _ctx.pt,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.pt = $event)),
                options: _ctx.plantTypesImages,
                optionLabel: "value",
                optionValue: "value",
                class: "p-selectbutton--blocks p-selectbutton--img-only m-3"
              }, {
                option: _withCtx((slotProps) => [
                  _createVNode("div", _hoisted_6, [
                    _createVNode("img", {
                      src: slotProps.option.imageURLs[0],
                      alt: "img"
                    }, null, 8, ["src"]),
                    _createVNode("div", _hoisted_7, [
                      _createVNode("strong", null, _toDisplayString(slotProps.option.title), 1)
                    ]),
                    _createVNode("div", _hoisted_8, _toDisplayString(slotProps.option.subTitle), 1)
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "options"]),
              (_ctx.pt == _ctx.Type.ENTRANCE_PLANT)
                ? (_openBlock(), _createBlock("div", _hoisted_9, [
                    _createVNode("div", _hoisted_10, [
                      _createVNode("h4", _hoisted_11, _toDisplayString(_ctx.$t("AppResourceEP.ChooseEntrancePlantTypeTitle")), 1),
                      _createVNode("p", _hoisted_12, _toDisplayString(_ctx.$t("AppResourceEP.ChooseEntrancePlantTypeDescription")), 1)
                    ]),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.residentialTypesButtons, (button, i) => {
                      return (_openBlock(), _createBlock(_component_Card, {
                        key: i,
                        class: ["residential-type-card m-3", {'residential-type-card--selected-type': button.value == _ctx.rt}],
                        onClick: ($event: any) => (_ctx.changeRtValue(button.value))
                      }, {
                        content: _withCtx(() => [
                          _createVNode("div", _hoisted_13, [
                            _createVNode("span", _hoisted_14, [
                              _createVNode(_component_InlineSvgScoped, {
                                src: button.imageURLs,
                                "aria-label": "icon-badge"
                              }, null, 8, ["src"])
                            ]),
                            _createVNode("div", _hoisted_15, [
                              _createVNode("h5", null, _toDisplayString(button.title), 1),
                              _createVNode("small", _hoisted_16, _toDisplayString(button.subTitle), 1)
                            ])
                          ])
                        ]),
                        _: 2
                      }, 1032, ["onClick", "class"]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}